const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {shallowEq} = require("../util/SCUUtil");

// This component only really exists for the shouldComponentUpdate optimization.
module.exports = createReactClass({
	displayName: "ScrollContent",

	propTypes: {
		children: PT.node,
		className: PT.string,
		style: PT.object,
	},

	shouldComponentUpdate: function(nextProps) {
		return !shallowEq(this.props, nextProps);
	},

	render: function() {
		const {children, className, style} = this.props;
		return (
			<div className={className} style={style}>
				{children}
			</div>
		);
	},
});
